import { __rest } from "tslib";
import React, { useRef, useState } from 'react';
import { makeStyles, Button, MenuItem as MuiMenuItem } from '@material-ui/core';
import clsx from 'clsx';
import { Popover } from '../..';
import { reactStyling, tokens } from '@getgo/chameleon-core';
const useStyles = makeStyles((theme) => {
    const { menuItem, menuItemHover } = reactStyling(theme.tokens);
    return {
        menuItem: Object.assign(Object.assign({}, menuItem), { padding: '0 1rem', '&:not(.Mui-disabled)': {
                '&:hover': Object.assign(Object.assign({}, menuItemHover), { color: tokens.optionColorSelected, backgroundColor: tokens.menuBackgroundHover, boxShadow: `0 0 0 0px`, 
                    // In order to achieve the achromatic icons on hover only
                    '&:not(:active)': {
                        '& p': {
                            color: tokens.text04,
                        },
                    }, '&.Mui-selected': {
                        backgroundColor: tokens.optionBackgroundSelected,
                        color: tokens.optionColorSelected,
                        '--goto-icon-color': tokens.optionIconColorSelected,
                    }, '&.Mui-focusVisible': {
                        boxShadow: tokens.highlight,
                        border: `1px solid ${tokens.inverseInteractive01}`,
                        backgroundColor: tokens.interactive01,
                        color: tokens.text04,
                    } }),
                '&.Mui-focusVisible': {
                    boxShadow: tokens.highlight,
                    border: `1px solid ${tokens.inverseInteractive01}`,
                    backgroundColor: tokens.interactive01,
                    color: tokens.text04,
                },
                '&.Mui-selected': {
                    backgroundColor: tokens.optionBackgroundSelected,
                    color: tokens.optionColorSelected,
                    '--goto-icon-color': tokens.optionIconColorSelected,
                },
            }, '&.Mui-disabled': {
                '--goto-icon-color': tokens.optionIconColorDisabled,
                color: tokens.optionColorDisabled,
            }, justifyContent: 'flex-start!important', 
            // @ts-ignore
            [`& .${window.CLASSNAME_PREFIX}-MuiButton-endIcon`]: {
                position: 'absolute',
                right: 20,
                top: 0,
                bottom: 0,
                margin: 'auto',
                height: 14,
                display: 'inline-flex',
            }, 
            // @ts-ignore
            [`& .${window.CLASSNAME_PREFIX}-MuiButton-iconSizeMedium > *:first-child`]: {
                // Vertically centers the icon
                fontSize: 'inherit',
                marginTop: '-2px',
            }, [`& .${window.CLASSNAME_PREFIX}-MuiButton-MuiButton-label`]: {
                alignItems: 'center',
            } }),
    };
});
export const MenuItem = React.forwardRef((_a, ref) => {
    var _b, _c;
    var { children, subItem, component = Button, className, popoverStyle, disabled, subItemDirection = 'right', onClick } = _a, otherProps = __rest(_a, ["children", "subItem", "component", "className", "popoverStyle", "disabled", "subItemDirection", "onClick"]);
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const itemRef = useRef(ref);
    return (React.createElement(React.Fragment, null,
        React.createElement(MuiMenuItem, Object.assign({ component: component, 
            // @ts-ignore
            ref: itemRef, className: clsx(classes.menuItem, className), onClick: (e) => {
                if (!disabled) {
                    if (onClick) {
                        onClick(e);
                    }
                    setOpen(true);
                }
            }, disabled: disabled, tabIndex: 0 }, otherProps), children),
        subItem && (React.createElement(Popover, { onPopover: () => setOpen(false), open: open, triggerRef: itemRef, style: popoverStyle !== null && popoverStyle !== void 0 ? popoverStyle : {}, anchorOrigin: {
                horizontal: subItemDirection === 'left' ? 0 : (_c = (_b = itemRef === null || itemRef === void 0 ? void 0 : itemRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) !== null && _c !== void 0 ? _c : 0,
                vertical: -10,
            }, disableScrollLock: open, transformOrigin: {
                vertical: 'top',
                horizontal: subItemDirection === 'left' ? 'right' : 'left',
            }, transparent: true }, subItem))));
});
